//@flow
import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Maybe } from "ramda-fantasy";
import moment from "moment";
import SelecaoDataInicialEFinal, {
  validacaoSelecaoDataInicialEFinal,
} from "./SelecaoDataInicialEFinal";
import {
  ID_AJUSTE_DIAS_NORMAL,
  ID_PERIODO_DIA_A_DIA,
  FORMATO_DATA_BANCO,
  type ErrosSelecao,
  type Id,
  type MedidaSelecionada,
} from "../../../../../model";
import {
  type State,
  type ProcessadorPeriodo,
  getPeriodoUnicoSelecionado,
  getDataBaseSelecionada,
  getDataInicialSelecionada,
  getDataFinalSelecionada,
  getDiasUteis,
  selecionarAjusteDias,
} from "../../../../../state";

type Props = {
  exibir: boolean,
};

const exibirSelecaoDiaADia: (state: State) => boolean = (state: State) =>
  getPeriodoUnicoSelecionado(state) === ID_PERIODO_DIA_A_DIA;

const useAutoTrocarAjusteDias = visivel => {
  const dispatch = useDispatch();

  const dataFinalSelecionada = moment(useSelector(getDataFinalSelecionada));
  const dataBase = moment(useSelector(getDataBaseSelecionada));

  useEffect(() => {
    if (visivel) {
      if (dataFinalSelecionada.isBefore(dataBase)) {
        dispatch(selecionarAjusteDias(ID_AJUSTE_DIAS_NORMAL));
      }
    }
  }, [dispatch, dataBase, dataFinalSelecionada, visivel]);
};

function SelecaoDiaADia({ exibir }: Props) {
  useAutoTrocarAjusteDias(exibir);

  if (!exibir) {
    return null;
  }

  return <SelecaoDataInicialEFinal />;
}

export const validacaoSelecaoDiaADia = function(state: State): ?ErrosSelecao {
  if (!exibirSelecaoDiaADia(state)) {
    return null;
  }
  return validacaoSelecaoDataInicialEFinal(state);
};

export const processarPeriodoDiaADia: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const _medidasSelecionadas: Array<MedidaSelecionada> = [];

  const dataInicialSelecionada = Maybe(getDataInicialSelecionada(state))
    .map(data => data.format(FORMATO_DATA_BANCO))
    .getOrElse("");

  const dataFinalSelecionada = Maybe(getDataFinalSelecionada(state))
    .map(data => data.format(FORMATO_DATA_BANCO))
    .getOrElse("");

  const diasUteis: Array<string> = getDiasUteis(state) || [];
  const datasUteisEntreSelecao: Array<string> = diasUteis.filter(
    dia => dia >= dataInicialSelecionada && dia <= dataFinalSelecionada
  );

  medidasSelecionadas.forEach(medidaSelecionada => {
    datasUteisEntreSelecao.forEach(dataUtil => {
      _medidasSelecionadas.push({
        ...medidaSelecionada,
        periodo,
        dataInicial: dataUtil,
        dataFinal: dataUtil,
      });
    });
  });

  return _medidasSelecionadas;
};

export default connect(
  (state: State) => ({
    exibir: exibirSelecaoDiaADia(state),
  }),
  {}
)(SelecaoDiaADia);
